module.exports = __webpack_public_path__ + "img/sobre-nosotros.d8cd2d6c.png";